import { Card } from '@sonnen/web-ui';
import { useAuth } from '@sonnen/web-utils/hooks';
import HouseWithCells700 from '../../../assets/images/HouseWithCells700.webp';
import HouseWithCells1400 from '../../../assets/images/HouseWithCells1400.webp';
import CroppedImage from '../../../components/CroppedImage/CroppedImage';
import { CustomUSPCard } from '../../../components/CustomUSPCard/CustomUSPCard';
import LoginPromptCard from '../../../components/LoginPromptCard/LoginPromptCard';
import { USPTypography } from '../../../components/USPTypography/USPTypography';
import { useTranslation } from '../../../i18n/i18n';
import EnergyFixBenefits from './EnergyFixBenefits';
import styles from './EnergyFixOverview.module.css';

const EnergyFixOverview = () => {
  const { authenticated } = useAuth();
  const { t } = useTranslation();

  return (
    <div data-testid="energyFix-overview">
      <Card paddingSize="md" className={styles.predictableCostsCard} dataTestId="predictable-costs">
        <div className={styles.predictableCostsCardText}>
          <USPTypography i18nScope="tariffOverview.energyFix.cardPredictableCosts" />
        </div>

        <CroppedImage
          height={216}
          src={HouseWithCells700}
          srcSet={`${HouseWithCells700} 1x, ${HouseWithCells1400} 2x`}
          dataTestId="predictable-costs-card-img"
          alt={t('tariffOverview.energyFix.cardPredictableCosts.imageAlt')}
        />
      </Card>

      <Card paddingSize="none" dataTestId="benefits">
        <EnergyFixBenefits />
      </Card>

      <CustomUSPCard i18nScope="tariffOverview.energyFix.cardSonnenApp" />

      {!authenticated && <LoginPromptCard i18nScope="loginPromptCard" />}
    </div>
  );
};

export default EnergyFixOverview;
